'use client';

import { useState, useEffect } from 'react';
import { plannerApi } from './planner.api';

/**
 * 해당 구역에 배정된 플래너 ID 목록 조회 훅
 */
export function useAssignedPlanners(
  regionId: string | undefined,
  date: string | undefined,
  enabled: boolean = true
): {
  plannerIds: string[];
  loading: boolean;
  error: Error | null;
} {
  const [plannerIds, setPlannerIds] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!enabled || !regionId || !date) {
      setLoading(false);
      setPlannerIds([]);
      return;
    }

    let cancelled = false;

    async function fetchAssignedPlanners() {
      try {
        setLoading(true);
        setError(null);

        const result = await plannerApi.searchPlannersByRegionAndDateRange(
          regionId!,
          date!,
          date!,
          100
        );

        if (!cancelled) {
          const ids = result.items?.map((p) => p.id) || [];
          setPlannerIds(ids);
        }
      } catch (err) {
        if (!cancelled) {
          const error = err instanceof Error ? err : new Error('Failed to fetch assigned planners');
          setError(error);
          console.error('Assigned planners fetch error:', error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    fetchAssignedPlanners();

    return () => {
      cancelled = true;
    };
  }, [regionId, date, enabled]);

  return {
    plannerIds,
    loading,
    error,
  };
}
